<template>
  <div class="billing-professional-transfer-legacy-page">
    <h6>Relação de repasses dos executantes</h6>
    <div class="columns" style="margin-bottom: 1rem;">
      <div class="column col-6 col-md-6 col-sm-12 form-group"
           :class="{'has-error': $v.filters.startDate.$error || $v.filters.endDate.$error}">
        <label class="form-label">Período</label>
        <st-date-period
          :start-date.sync="filters.startDate"
          :end-date.sync="filters.endDate"
          :start-date-validator="$v.filters.startDate"
          :end-date-validator="$v.filters.endDate"
          :max-months="4"
          @blur:startDate="$v.filters.startDate.$touch()"
          @blur:endDate="$v.filters.endDate.$touch()"
        />
      </div>
      <div class="column col-6 col-md-6 col-sm-12 form-group">
        <label class="form-label">Profissional</label>
        <select id="report-professional" class="form-select"
                v-model="filters.professionalId">
          <option value="">[Todos os profissionais]</option>
          <option v-for="(item, i) in professionals" :value="item.id" :key="i">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="column col-3 col-md-12 col-sm-12 form-group">
        <label class="form-label">Status da fatura</label>
        <st-multi-select
          v-model="filters.statuses"
          :items="statusItems"
          value-key="value"
          label-key="label"
        />
      </div>
      <div class="column col-3 col-md-3 col-sm-12 form-group">
        <label class="form-label">Agrupado por</label>
        <select id="group" class="form-select" v-model="filters.group">
          <option value="insurance">Convênio</option>
          <option value="professional">Profissional</option>
          <option value="expense">Serviço</option>
        </select>
      </div>
      <div class="column col-2 col-md-3 col-sm-12 form-group">
        <label class="form-label">Retornos</label>
        <select id="return" class="form-select" v-model="filters.return">
          <option value="true">Exibir</option>
          <option value="false">Não</option>
        </select>
      </div>
      <div class="column col-2 col-md-3 col-sm-12 form-group">
        <label class="form-label">Cortesias</label>
        <select id="courtesy" class="form-select" v-model="filters.courtesy">
          <option value="true">Exibir</option>
          <option value="false">Não</option>
        </select>
      </div>
      <div class="column col-2 col-md-3 col-sm-12 form-group">
        <label class="form-label">Situação</label>
        <select id="paid" class="form-select" v-model="filters.paid">
          <option value="">Todos</option>
          <option value="true">Pagos</option>
          <option value="false">Pendentes</option>
        </select>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing}"
              @click="print" :disabled="printing">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { date, minDate } from '@/data/validators';
import { statuses as invoiceStatuses } from 'src/data/invoice-statuses';
import * as professionalApi from '@/app/professional/api';

export default {
  props: {
    printPath: {
      type: String,
      default: '/professional-transfer/print',
    },
  },
  data() {
    return {
      printing: false,
      professionals: [],
      filters: {
        startDate: '',
        endDate: '',
        professionalId: '',
        group: 'professional',
        return: false,
        courtesy: false,
        statuses: ['finished'],
        paid: '',
      },
    };
  },
  validations() {
    const rules = {
      filters: {
        startDate: { date, required },
        endDate: { date, required },
      },
    };
    if (this.filters.startDate && this.filters.startDate.length === 10) {
      rules.filters.endDate = {
        date,
        required,
        minDate: minDate(this.filters.startDate),
      };
    }

    return rules;
  },
  mounted() {
    this.filters.startDate = moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filters.endDate = moment()
      .endOf('month')
      .format('YYYY-MM-DD');
    this.loadProfessionals();
  },
  computed: {
    statusItems() {
      return Object.keys(invoiceStatuses).map(key => ({
        value: key,
        label: invoiceStatuses[key],
      }));
    },
  },
  methods: {
    print() {
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return false;
      }
      const duration = moment.duration(moment(this.filters.endDate)
        .diff(moment(this.filters.startDate))).asMonths();

      if (duration > 4) {
        this.$toast.show('Período limite (4 meses)', { type: 'error' });
        return false;
      }

      this.printing = true;

      const params = {
        group: this.filters.group,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        return: this.filters.return,
        statuses: this.filters.statuses.join(','),
      };

      if (this.filters.professionalId) {
        params.professionalId = this.filters.professionalId;
      }

      if (this.filters.paid !== '') {
        params.paid = this.filters.paid;
      }

      if (this.filters.return !== '') {
        params.return = this.filters.return;
      }

      if (this.filters.courtesy !== '') {
        params.courtesy = this.filters.courtesy;
      }

      return this.$file
        .print(this.printPath, params)
        .catch(() => {})
        .then(() => {
          this.printing = false;
        });
    },
    loadProfessionals() {
      professionalApi.allActive()
        .then((data) => {
          this.professionals = data.items;
        })
        .catch(this.$toast.error);
    },
  },
};
</script>

<style lang="scss">
  @import "../../../assets/scss/variables";
  .billing-professional-transfer-legacy-page {
    .footer {
      margin-top: $layout-spacing-lg;
      text-align: right;
    }
  }
</style>
